import { useMemo } from 'react';
import UserPointItem from './Item';
import {
  AVERAGE_SCORE_BY_CLUSTER,
  SECTION_TITLE_COLOR_BY_CLUSTER,
  CLUSTER,
  EVALUATION_BACKGROUND_COLOR_BY_CLUSTER,
  EVALUATION_BORDER_COLOR_BY_CLUSTER,
} from '../constants';

import turnoverGood from 'app/assets/images/turnover_good.png';
import turnoverCentral from 'app/assets/images/turnover_central.png';
import turnoverBad from 'app/assets/images/turnover_bad.png';
import oxidationGood from 'app/assets/images/oxidation_good.png';
import oxidationCentral from 'app/assets/images/oxidation_central.png';
import oxidationBad from 'app/assets/images/oxidation_bad.png';
import drynessGood from 'app/assets/images/dryness_good.png';
import drynessCentral from 'app/assets/images/dryness_central.png';
import drynessBad from 'app/assets/images/dryness_bad.png';

export const turnoverImages = [turnoverGood, turnoverCentral, turnoverBad];
export const oxidationImages = [oxidationGood, oxidationCentral, oxidationBad];
export const drynessImages = [drynessGood, drynessCentral, drynessBad];

const UserPoint = ({ scalpData, metricsAdvice, isTablet }) => {
  const averages = useMemo(
    () => AVERAGE_SCORE_BY_CLUSTER[scalpData?.factorCluster] ?? [0, 0, 0],
    [scalpData?.factorCluster],
  );

  const sectionTitleColor = SECTION_TITLE_COLOR_BY_CLUSTER[scalpData?.factorCluster] ?? '#64748B';

  const isClusterE = [CLUSTER.E_CLASS, CLUSTER.BD_CLASS, CLUSTER.ED_CLASS].includes(
    scalpData?.factorCluster?.toString(),
  );
  const bgColor = isClusterE ? EVALUATION_BACKGROUND_COLOR_BY_CLUSTER[CLUSTER.E_CLASS] : undefined;
  const borderColor = isClusterE ? EVALUATION_BORDER_COLOR_BY_CLUSTER[CLUSTER.E_CLASS] : undefined;
  const interpretationColor = isClusterE ? SECTION_TITLE_COLOR_BY_CLUSTER[CLUSTER.E_CLASS] : undefined;

  return (
    <section className="space-y-6 w-full" id="metrics">
      <UserPointItem
        code="TO-01"
        label="細胞面積"
        labelEn="Turnover"
        point={scalpData?.factorCellArea}
        ratio={scalpData?.ratioCA}
        avg={averages[0]}
        isTablet={isTablet}
        microscopeImages={turnoverImages}
        interpretation={metricsAdvice?.['TO-01']?.interpretation}
        recommendation={metricsAdvice?.['TO-01']?.recommendation}
        sectionTitleColor={sectionTitleColor}
        bgColor={bgColor}
        borderColor={borderColor}
        interpretationColor={interpretationColor}
      />
      <UserPointItem
        code="OX-02"
        label="カルボニルタンパク"
        labelEn="Oxidation"
        point={scalpData?.factorCP}
        ratio={scalpData?.ratioCP}
        avg={averages[2]}
        isTablet={isTablet}
        microscopeImages={oxidationImages}
        interpretation={metricsAdvice?.['OX-02']?.interpretation}
        recommendation={metricsAdvice?.['OX-02']?.recommendation}
        sectionTitleColor={sectionTitleColor}
        bgColor={bgColor}
        borderColor={borderColor}
        interpretationColor={interpretationColor}
      />
      <UserPointItem
        code="DR-03"
        label="多重剥離度"
        labelEn="Dryness"
        point={scalpData?.factorPeeling}
        ratio={scalpData?.ratioMP}
        avg={averages[1]}
        isTablet={isTablet}
        microscopeImages={drynessImages}
        interpretation={metricsAdvice?.['DR-03']?.interpretation}
        recommendation={metricsAdvice?.['DR-03']?.recommendation}
        sectionTitleColor={sectionTitleColor}
        bgColor={bgColor}
        borderColor={borderColor}
        interpretationColor={interpretationColor}
      />
    </section>
  );
};

export default UserPoint;
